<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :filterOfLots="false"
              :onlyFarmsFruits="true"
              :isDrawerContent="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              @onChangeFilters="onChangeFilters"
              classFarms="col-12"
            >
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>

      <template v-if="showGraph">
        <section id="loss">
          <div class="row">
            <div
              class="col-md-8"
              v-if="chartOptions[0] && Object.keys(chartOptions[0]).length > 0"
            >
              <card class="dashboard-card">
                <div class="row d-flex" style="justify-content: end">
                  <div class="col-md-4 col-lg-3">
                    <card class="dashboard-card kpi-merma-card">
                      <h2 class="kpi-number">{{ totalPlanLoss }} %</h2>
                      <span class="kpi-title">{{ $t('grow.plan_loss') }}</span>
                    </card>
                  </div>
                </div>
                <highcharts :options="chartOptions[7]"></highcharts
              ></card>
            </div>
            <div
              class="col-md-4"
              v-if="chartOptions[0] && Object.keys(chartOptions[0]).length > 0"
            >
              <card class="dashboard-card">
                <!--<card-header
                        :propPagination="pagination"
                        @searchedQuery="searchedQuery"
                        class="mr-3 mt-1"
                      />-->
                <el-table
                  stripe
                  :default-sort="{
                    prop: 'percentage',
                    order: 'descending',
                  }"
                  :data="queriedData"
                  max-height="280"
                  style="width: 100%"
                  :border="true"
                >
                  <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :fixed="column.fixed"
                    :sortable="column.sortable"
                    :align="column.align"
                    :resizable="false"
                  >
                    <template slot-scope="props">
                      <span v-if="column.prop == 'farm'"
                        >{{ props.row[column.prop] }}
                      </span>

                      <span
                        v-else-if="column.prop == 'percentage'"
                        :style="
                          props.row.percentage > props.row.planLoss
                            ? 'color:red'
                            : 'color:green'
                        "
                      >
                        {{ props.row[column.prop] }} %
                      </span>
                      <span v-else>{{ props.row[column.prop] }} %</span>
                    </template>
                  </el-table-column>
                </el-table>
                <!--<card-footer
                        ref="cardfooter"
                        :propPagination="pagination"
                      />-->
                <highcharts :options="chartOptions[0]"></highcharts
              ></card>
            </div>
          </div>
        </section>
        <section id="loss-category">
          <div class="row">
            <div
              class="col-md"
              v-if="chartOptions[1] && Object.keys(chartOptions[1]).length > 0"
            >
              <card class="dashboard-card">
                <highcharts :options="chartOptions[1]"></highcharts>
              </card>
            </div>
            <div
              class="col-md"
              v-if="chartOptions[2] && Object.keys(chartOptions[2]).length > 0"
            >
              <card class="dashboard-card">
                <highcharts :options="chartOptions[2]"></highcharts
              ></card>
            </div>
            <div
              class="col-md"
              v-if="chartOptions[3] && Object.keys(chartOptions[3]).length > 0"
            >
              <card class="dashboard-card">
                <highcharts :options="chartOptions[3]"></highcharts
              ></card>
            </div>
          </div>
        </section>
        <section id="loss-category">
          <div class="row">
            <div
              class="col-md"
              v-if="chartOptions[4] && Object.keys(chartOptions[4]).length > 0"
            >
              <card class="dashboard-card">
                <highcharts :options="chartOptions[4]"></highcharts>
              </card>
            </div>
            <div
              class="col-md"
              v-if="chartOptions[5] && Object.keys(chartOptions[5]).length > 0"
            >
              <card class="dashboard-card">
                <highcharts :options="chartOptions[5]"></highcharts
              ></card>
            </div>
            <div
              class="col-md"
              v-if="chartOptions[6] && Object.keys(chartOptions[6]).length > 0"
            >
              <card class="dashboard-card">
                <highcharts :options="chartOptions[6]"></highcharts
              ></card>
            </div>
          </div>
        </section>
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import Filter from 'src/components/Filter/Filters.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';

import { Chart } from 'highcharts-vue';
import MixinCharts from 'src/util/mixinCharts';
import SweetAlert from 'src/class/Alerts';

import { Pagination as LPagination } from 'src/components/index';
import Fuse from 'fuse.js';
import configTable from './LossRankingTable';

export default {
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
    [Filter.name]: Filter,
    highcharts: Chart,
    LPagination,
  },

  data() {
    return {
      reportType: 0,
      activeName: 'filter',
      valueCollapse: null,
      dataFilter: [],
      farms: null,
      openCollapse: false,
      chartOptions: [],
      data: [],
      showGraph: false,
      totalPlanLoss: 0,

      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      tableData: [],
      searchQuery: '',
      fuseSearch: null,
    };
  },
  mixins: [mixinMasters, MixinMenu, MixinCharts, MixinPermissions],
  computed: {
    ...configTable().Search,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      if (this.reportType === null || ![0, 1].includes(Number(this.reportType)))
        return this.validationInputsRequired('type');
      else {
        this.seletedData = {};
        this.dataFilter = { ...data, reportType: this.reportType };
        this.getReportInfo();
      }
    },
    onChangeFilters() {
      this.showGraph = false;
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
    getReportInfo() {
      this.showGraph = false;
      this.setupTable();
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'grow/lossreport/getreportinfo';
      Axios.postMasters(data)
        .then((response) => {
          this.data = response.data.data;

          if (this.data && this.data.tableData)
            this.tableData = this.data.tableData;
          else this.tableData = [];
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((column) => {
              return column.prop;
            }),
          });
          this.pagination.perPage = this.tableData.length;
          this.totalPlanLoss = this.data.planLoss;
          let graphs = this.data.graphs ? this.data.graphs : [];
          if (!Array.isArray(graphs)) {
            graphs = Object.values(graphs);
          }
          if (
            this.data &&
            this.data.graphs &&
            Object.keys(this.data.graphs).length > 0
          ) {
            this.chartOptions = [];
            graphs.forEach((item, index) => {
              if (item && Object.keys(item).length > 0) {
                this.$set(
                  this.chartOptions,
                  index,
                  JSON.parse(JSON.stringify(this.graph(item))) // aqui hacemos la asignacion del metodo que vamos a usar del mixinCharts
                );
              }
            });
            this.showGraph = this.chartOptions.length > 0;
          } else {
            this.showGraph = false;
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
        })
        .catch((error) => {
          this.showMessageErrors(error);
        })
        .finally(() => {
          this.showHideLoading();
        });
    },
  },

  mounted() {
    this.selectedItemOnMenu('lossreport');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('lossreport');
  },
};
</script>
<style scoped>
::v-deep .dashboard-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05),
    0 8px 10px -6px rgba(0, 0, 0, 0.01);
  border: 1px solid #f1f5f9;
}

::v-deep .dashboard-card > .card-body {
  padding: 5px !important;
}

::v-deep .kpi-merma-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2px;
  border-bottom: 4px solid #4f8949;
}

::v-deep .kpi-number {
  font-size: 1.8rem;
  font-weight: 800;
  color: #898989;
  margin: 0;
  line-height: 1;
}

::v-deep .kpi-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #898989;
  letter-spacing: 1.5px;
  margin-top: 8px;
}
</style>